module.exports = [{"type":"flavor","text":"You buy a Meiji chocolate, for some reason.","filters":[{"type":"resource","resource":"yen","minimum":100}],"effects":[{"type":"resource","resource":"yen","value":-100}]},{"type":"flavor","text":"As you approach the vending machine, you realize you forgot your wallet at home. Somehow you got through the TSA anyways. Looks like you'll be thirsty until you can get some cash.","filters":[],"effects":[]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/collections/vending-machine-event.json
// module id = 86
// module chunks = 0